<template>
  <div class="cencent">

    <div style="padding:10px">
      <el-button size="mini" type="primary" @click="dialogVisible=true">添加</el-button>
    </div>


    <el-dialog
      title="提示"
      fullscreen
      :show-close="false"
      :visible.sync="dialogVisible"
    >




      <div slot="title" style="text-align: right">
        <el-button @click="dialogVisible = false" size="mini">关 闭</el-button>
        <el-button type="primary" @click="dialogVisible = false" size="mini">保 存</el-button>
      </div>

    </el-dialog>


  </div>


</template>

<script>
export default {
  name: "field",
  data() {
    return {
      dialogVisible: false,
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: ''
      }
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/module/admin/field.vue